import { updateRatesGlobalRequest } from "../../data/ratesGlobalApi";
import { validateTarifaGlobalEnterprisePayload } from "../validator/validateTarifaGlobalEnterprisePayload";

export async function updateTarifaGlobalEnterpriseUseCase(payload) {
  if (!payload?.id) {
    throw new Error("El id de la tarifa global es obligatorio.");
  }

  const error = validateTarifaGlobalEnterprisePayload(payload);

  if (error) {
    throw new Error(error);
  }

  return await updateRatesGlobalRequest(payload);
}
